import React, { FC } from 'react';
import UserManagementRoutes from './components/UserManagementRoutes';
import PopoverProvider from './context/PopoverProvider';
import { UserManagementProvider, useUsers } from './context/UserManagementContext';
import { DrawerProvider } from './context/DrawerProvider';
import { PopupProvider } from './context/PopupProvider';
import { SnackAlertProvider } from './context/SnackAlertProvider';

const UserManagement: FC = () => {
    const { userSession, loadingUserSession } = useUsers();

    if (loadingUserSession) {
        return (
            <div className="silverfort-loader">
                <div className="logo"></div>
            </div>
        );
    }

    if (!userSession) {
        return null;
    }

    return <UserManagementRoutes />;
};

const Providers: FC = ({ children }) => {
    return (
        <UserManagementProvider>
            <SnackAlertProvider>
                <PopoverProvider>
                    <PopupProvider>
                        <DrawerProvider>{children}</DrawerProvider>
                    </PopupProvider>
                </PopoverProvider>
            </SnackAlertProvider>
        </UserManagementProvider>
    );
};

const UserManagementWithProviders: FC = () => {
    return (
        <Providers>
            <UserManagement />
        </Providers>
    );
};

export default UserManagementWithProviders;
